import { useState } from 'react'

import { Space } from 'app/common/templates-next/report-template'
import { useUser } from 'app/dataProviders/user/hooks'
import { useFilterApplied, useFilterActivity } from 'app/filters/reports/averageCheck/filterStore'

import { Filters } from './filters'
import { Result } from './result'

export const AverageCheck = ({ profileLink }: { profileLink: string }) => {
  const [reportId, setReportId] = useState<null | string>(null)
  const { email } = useUser()

  return (
    <>
      <Filters email={email} onReportId={setReportId} profileLink={profileLink} />
      <Space />
      <Result reportId={reportId} onReportId={setReportId} />
    </>
  )
}
